const firebaseConfig = {
  apiKey: "AIzaSyDLiOIw1nooA32u_xq9rtJKfV0HCUfDH9Q",
  authDomain: "orvsp-369c0.firebaseapp.com",
  projectId: "orvsp-369c0",
  storageBucket: "orvsp-369c0.appspot.com",
  messagingSenderId: "316543860947",
  appId: "1:316543860947:web:5839c146847262e1151426"
};
export default firebaseConfig;
